import { useState } from "react";
import { toast } from "sonner";
import { Copy, MessageCircle, Facebook, Instagram } from "lucide-react";

export default function ShareButtons({ deal }) {
  const [url] = useState(typeof window !== "undefined" ? window.location.href : "");
  const text = `▌ RESTRICTED DEAL — ${deal.from_city} → ${deal.to_city} for €${deal.price_eur} on ${deal.airline}`;
  const wa = `https://wa.me/?text=${encodeURIComponent(`${text}\n${url}`)}`;
  const fb = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("LINK COPIED");
    } catch {
      toast.error("COULD NOT COPY");
    }
  };

  const copyInsta = async () => {
    try {
      await navigator.clipboard.writeText(`${text}\n${url}`);
      toast.success("CAPTION COPIED — PASTE INTO INSTAGRAM");
    } catch {
      toast.error("COULD NOT COPY");
    }
  };

  return (
    <div className="flex flex-wrap gap-3" data-testid="share-buttons">
      <a href={wa} target="_blank" rel="noreferrer" className="btn-rd-outline" data-testid="share-whatsapp">
        <MessageCircle className="w-4 h-4" /> WHATSAPP
      </a>
      <button onClick={copyInsta} className="btn-rd-outline" data-testid="share-instagram">
        <Instagram className="w-4 h-4" /> INSTAGRAM
      </button>
      <a href={fb} target="_blank" rel="noreferrer" className="btn-rd-outline" data-testid="share-facebook">
        <Facebook className="w-4 h-4" /> FACEBOOK
      </a>
      <button onClick={copyLink} className="btn-rd-outline" data-testid="share-copy">
        <Copy className="w-4 h-4" /> COPY LINK
      </button>
    </div>
  );
}
